var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _g2, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 264 264",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m264.13 132c0 72.974-59.157 132.13-132.13 132.13-72.975 0-132.13-59.16-132.13-132.13 0-72.973 59.157-132.13 132.13-132.13 72.976 0 132.13 59.159 132.13 132.13z",
    fill: "#2CA7B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    x: -1,
    y: -1,
    width: 265,
    height: 265,
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m-0.2666 131.87c0 72.975 59.157 132.13 132.13 132.13 72.975 0 132.14-59.157 132.14-132.13 0-72.976-59.16-132.13-132.14-132.13-72.974 0-132.13 59.157-132.13 132.13z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m156.08 168.55c13.889-7.156 24.782-20.582 29.882-36.132 0.744 0.286 1.519 0.454 2.322 0.454 5.149 0 9.322-6.261 9.322-13.984 0-7.577-4.021-13.732-9.036-13.961-3.8-27.553-26.852-48.75-54.737-48.75-27.935 0-51.017 21.273-54.754 48.902-0.4547-0.102-0.916-0.172-1.3894-0.172-5.148 0-9.3213 6.26-9.3213 13.982 0 7.723 4.1733 13.984 9.3213 13.984 1.348 0 2.624-0.437 3.78-1.208 4.9427 15.711 15.788 29.335 29.695 36.662v20.248c-26.26 3.661-27.507 5.634-27.507 5.634l2.2947 7.34 47.67 26.24 52.119-26.24s-1.028-8.412-29.661-12.806v-20.192z",
    fill: "#FFC78C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m163.98 190s-10.514 18.121-32.117 18.389c-21.601-0.268-32.116-18.389-32.116-18.389-39.407 0-64.407 46.188-64.407 46.188l96.523 47.35 96.525-47.35s-25-46.188-64.408-46.188z",
    fill: "#FE4A49"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m99.749 190s12.095 26.854 14.639 27.172c2.541 0.317 12.579-9.163 12.579-9.163l-27.218-18.009z",
    fill: "#FBFEFD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m163.98 190s-11.437 26.854-13.978 27.172c-2.544 0.317-12.018-9.359-12.018-9.359l25.996-17.813z",
    fill: "#FBFEFD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m84.216 131.46c5.3173-1.285-2.5734-36.074 5.4053-44.565 7.9733-8.492 20.334 2.7773 46.4 3.0867 26.065 0.308 30.105-11.149 39.969-3.0014 9.864 8.1467-0.039 32.96 5.449 44.257 2.004 4.122 4.52-26.11 4.52-26.11s4.235-0.398 6.474 1.256c10.702-21.944 6.269-25.75 3.648-33.556-3.58-10.665-14.854-13.388-2.66-26.177 10.549-11.064-12.26-13.637-58.427-6.432-22.665 3.536-45.148-7.6534-60.298 12.609-12.68 16.957-7.8747 27.331 0.6453 51.236 1.2707-1.378 2.9107 1.5 3.1773 1.4 2.732 7.594 4.58 26.268 5.6974 25.997z",
    fill: "#332114"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    x: 140,
    y: 100,
    width: 43,
    height: 28,
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m140.26 100.18h42.382v27.331h-42.382v-27.331z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.39999
  }, /*#__PURE__*/React.createElement("path", {
    d: "m140.66 100.18h41.949s1.908 27.331-22.459 27.331c-24.364 0-19.49-27.331-19.49-27.331z",
    fill: "#fff"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m141.77 101.45c-0.363 3.193-0.96 12.95 4.261 19.174 3.124 3.726 7.876 5.614 14.12 5.614 6.334 0 11.354-1.942 14.924-5.77 5.782-6.2 6.303-15.71 6.296-19.018h-39.601zm18.381 27.33c-7.037 0-12.445-2.197-16.076-6.53-7.044-8.411-4.766-21.732-4.666-22.295l0.186-1.048h44.202l0.081 1.1831c0.039 0.557 0.863 13.742-6.944 22.112-4.071 4.365-9.716 6.578-16.783 6.578z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    x: 85,
    y: 100,
    width: 43,
    height: 28,
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m85.125 100.18h42.383v27.331h-42.383v-27.331z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.39999
  }, /*#__PURE__*/React.createElement("path", {
    d: "m127.11 100.18h-41.95s-1.9067 27.331 22.459 27.331c24.365 0 19.491-27.331 19.491-27.331z",
    fill: "#fff"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m86.4 101.45c-0.0067 3.308 0.5133 12.818 6.2946 19.018 3.5707 3.828 8.5921 5.77 14.924 5.77 6.247 0 10.996-1.888 14.12-5.614 5.221-6.224 4.625-15.981 4.261-19.174h-39.6zm4.436 20.752c-7.8054-8.37-6.9827-21.555-6.9427-22.112l0.0827-1.1831h44.199l0.187 1.048c0.101 0.5631 2.377 13.884-4.666 22.295-3.63 4.333-9.04 6.53-16.077 6.53-7.067 0-12.712-2.213-16.783-6.578z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m140.26 108.54h-12.955v-4.661h12.955v4.661z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m191.64 108.43-8.655 0.934v-4.408l10.737-1.696-2.082 5.17z",
    fill: "#231F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m76.883 107.74 8.2427 1.201v-4.408l-10.325-1.962 2.0826 5.169z",
    fill: "#231F20"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 264,
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2);
export default __webpack_public_path__ + "static/media/profile-2.9b5216a2f62cdd8f367774cedfd60a23.svg";
export { ForwardRef as ReactComponent };